import { render, staticRenderFns } from "./PrivacyValue.vue?vue&type=template&id=8c6bc772&scoped=true"
import script from "./PrivacyValue.vue?vue&type=script&lang=js"
export * from "./PrivacyValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6bc772",
  null
  
)

export default component.exports